import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { cssClass } from '~src/style';

const SECURITY_SITE_SETTINGS_PREFIX = 'security-site-settings';
const SETTINGS_CONTAINER_INDENT = '85px';

export const securitySiteSettingsSpaceContainer = cssClass(SECURITY_SITE_SETTINGS_PREFIX, 'space', {
  display: 'block',
  paddingTop: CommonStyles.Sizes.XLargeSpace,
  marginLeft: SETTINGS_CONTAINER_INDENT,
});